import { StoreItemCategory } from '../../../../shared/entity_datas/StoreEnums.ts';
import { UIWStoreBodyController } from './UIWStoreBodyController.ts';
import { ColonistCoinProduct } from '../../../../shared/store/ColonistCoinProduct.ts';
import { UIDCoinProductView } from './UIDCoinProductView.ts';
import { createDivIn } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import * as Item from '../../../../shared/store/StoreItemList.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { UIDStoreMembershipProductView } from './UIDStoreMembershipProductView.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { showSimpleDialog } from '../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { ColonistMembershipType } from '@colonist/types';
import { DiscordInstance } from '../discord/DiscordInstance.ts';
import { SDKRequest } from '../../../../shared/DiscordActivityTypes.ts';
import { PaymentMethod } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { UIDStoreMembershipTabsController } from '../../../shared/scripts/store/UIDStoreMembershipTabsController.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { getManageSubscriptionPopupBody, isPurchaseUnavailableOnPlatform, showUnavailableOnMobilePopup } from '../../../shared/scripts/store/StoreUtils.ts';
import { UIDStoreGiftOverlayController } from './UIDStoreGiftOverlayController.ts';
export class UIDStoreBodyController extends UIWStoreBodyController {
    createGiftOverlay() {
        const sceneContainer = document.getElementById('scene_discord_gifting_container');
        this.giftOverlayController = new UIDStoreGiftOverlayController(sceneContainer, this.storeState);
    }
    createMembershipItems() {
        this.membershipsDiv.replaceChildren();
        this.membershipItems.length = 0;
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts();
        for (const product of membershipProducts){
            const giftOverlay = UIUtilsEjsVariables.isUserOnDiscordMobile ? undefined : this.giftOverlayController;
            const membership = new UIDStoreMembershipProductView(this.membershipsDiv, this.storeState, product, giftOverlay);
            this.membershipItems.push(membership);
        }
        this.membershipTabsController = new UIDStoreMembershipTabsController(this.storeState);
        // To avoid the element occupy the whole width
        createDivIn(this.membershipsDiv, '');
    }
    updateAllCategoryItems() {
        var _ClientUserState_userState;
        this.items.length = 0;
        this.updateCategoryItems(StoreItemCategory.Expansion, this.expansionsDiv);
        this.updateCategoryItems(StoreItemCategory.Map, this.mapsDiv);
        this.updateCategoryItems(StoreItemCategory.Color, this.colorsDiv);
        this.updateCategoryItems(StoreItemCategory.Icon, this.avatarsDiv);
        if (isPurchaseUnavailableOnPlatform()) {
            this.setUnavailableOnMobileActions();
            return;
        }
        if (((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.forceSubscription) === false) return;
        this.setSubscribeClickActions();
    }
    updateOwnedMembership(ownedMembership, paymentMethod) {
        this.createMembershipItems();
        if (ownedMembership == undefined) return;
        const disableMembershipManagement = paymentMethod != PaymentMethod.Discord && paymentMethod != PaymentMethod.Stripe;
        for (const membershipView of this.membershipItems){
            if (disableMembershipManagement) {
                if (membershipView.membershipProduct.type == ownedMembership.type) {
                    membershipView.changeToOwnedButton();
                    continue;
                }
                membershipView.removeButton();
                continue;
            }
            membershipView.changeToManageButton();
        }
    }
    updateSubscribedItems(ownedMembership, paymentMethod) {
        if (ownedMembership == undefined) return;
        switch(ownedMembership.type){
            case ColonistMembershipType.PlusMonthly:
            case ColonistMembershipType.PlusYearly:
                this.markItemsAsManageSubscription(StoreItemCategory.Map);
                this.markItemsAsManageSubscription(StoreItemCategory.Expansion);
                this.markItemsAsManageSubscription(StoreItemCategory.Color);
                break;
            case ColonistMembershipType.Holiday2023AllAccessPass:
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                this.markItemsAsSubscribed(StoreItemCategory.Map);
                this.markItemsAsSubscribed(StoreItemCategory.Expansion);
                this.markItemsAsManageSubscription(StoreItemCategory.Color);
                break;
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
                this.markItemsAsSubscribed(StoreItemCategory.Map);
                this.markItemsAsSubscribed(StoreItemCategory.Expansion);
                this.markItemsAsSubscribed(StoreItemCategory.Color);
                break;
        }
    }
    markItemsAsSubscribed(category) {
        for (const item of this.items){
            if (!UIDStoreBodyController.shouldUpdateItemView(item)) continue;
            if (item.itemDetail.category != category) continue;
            item.markAsSubscribed();
            item.updateAction(()=>{
                UIDStoreBodyController.showSubscribedItemPopup();
            });
        }
    }
    markItemsAsManageSubscription(category) {
        for (const item of this.items){
            if (!UIDStoreBodyController.shouldUpdateItemView(item)) continue;
            if (item.itemDetail.category != category) continue;
            item.updateAction(()=>{
                UIDStoreBodyController.showManageSubscriptionOnWebPopup();
            });
        }
    }
    createCoinProducts() {
        const coinProducts = ColonistCoinProduct.getAllCoinProducts();
        for (const product of coinProducts){
            new UIDCoinProductView(this.coinsDiv, product);
        }
    }
    setSubscribeClickActions() {
        for (const item of this.items){
            if (!UIDStoreBodyController.shouldUpdateItemView(item)) continue;
            if (item.itemDetail.category == StoreItemCategory.Color) {
                item.updateAction(()=>{
                    void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.EliteMonthly);
                });
                continue;
            }
            item.updateAction(()=>{
                void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly);
            });
        }
    }
    setUnavailableOnMobileActions() {
        for (const item of this.items){
            if (!UIDStoreBodyController.shouldUpdateItemView(item)) continue;
            item.updateAction(()=>{
                showUnavailableOnMobilePopup();
            });
        }
    }
    static shouldUpdateItemView(itemView) {
        const isItemOwned = itemView.isMarkedOwned;
        if (isItemOwned) return false;
        const isBlackColor = itemView.itemDetail.name.key === new Item.SIColorBlack().name.key;
        if (isBlackColor) return false;
        const isItemAnIcon = itemView.itemDetail.category === StoreItemCategory.Icon;
        if (isItemAnIcon) return false;
        return true;
    }
    static showComingSoonPopup() {
        const popupTitle = {
            key: 'strings:popups.comingSoon.title'
        };
        const popupBody = {
            key: 'strings:popups.comingSoon.body',
            options: {
                context: 'membership'
            }
        };
        showSimpleDialog({
            title: popupTitle,
            body: popupBody
        });
    }
    static showSubscribedItemPopup() {
        const popupTitle = {
            key: 'strings:storePage.subscribedItem.title'
        };
        const popupBody = {
            key: 'strings:storePage.subscribedItem.body'
        };
        showSimpleDialog({
            title: popupTitle,
            body: popupBody
        });
    }
    static showManageSubscriptionOnWebPopup() {
        const popupTitle = {
            key: 'strings:storePage.manageMembership.title'
        };
        const popupBody = getManageSubscriptionPopupBody();
        showSimpleDialog({
            title: popupTitle,
            body: popupBody
        });
    }
    // eslint-disable-next-line class-methods-use-this
    onInviteFriendsButtonClick(referralReward, userReferralCount) {
        DiscordInstance.getDiscordInstance().shareStoreReferral(referralReward);
    }
}
